module.exports = __webpack_public_path__ + "../resources/img/ic_error_weather.2c8b2e41.svg";